import React from 'react';
import AdminTable from 'layouts/AdminTable';
import DataGrid from 'components/DataGrid/DataGrid';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import columnConfig from './columnConfig';

const List = ({ t, currency }) => (
  <AdminTable title={t('list.products')}>
    <DataGrid
      actions={true}
      editPath={`${window.location.pathname}/edit`}
      paginationTop={true}
      paginationBottom={false}
      url="products"
      reportName="product"
      columns={columnConfig(t, currency)}
      role="PRODUCT"
    />
  </AdminTable>
);

const mapStateToProps = state => ({
  currency: state.Brands.brand.multinational.currency,
});

const enhance = compose(withTranslation(), connect(mapStateToProps));

export default enhance(List);
